<template>	
	<div class="main-stepper" style="height: calc(100vh - 260px);overflow-y:auto;margin-bottom:10px;">
		<div class="main-stepper">
			<div class="step-content">
				<div class="header-step-stepper">
					<md-avatar class="md-avatar-icon stepper-content-num" :class="{active:activeStep1}">
						<span v-if="stepNo==1">{{stepNo}}</span>
						<md-icon class='step-icon' v-if="stepNo!=1">mode_edit</md-icon>
					</md-avatar>
					<span class="card-title" :class="{active:activeStep1}">Basic Info</span>
				</div>
				<div v-if="value.campaign_code || value.campaign_title || value.campaign_detail || value.startdate || value.enddate">
					<div class='step-content-line'>
						<p class='text active'>
							<!-- <span class="title-step1">{{value}}</span> -->
							<div>
								<span class="data-title">{{value.campaign_code}}</span>
								<span class="data-disciption">{{value.campaign_title}}</span>
							</div>
							<div class="data-date">{{genDateView(value.startdate,value.enddate)}}</div>
							<div>
								<span class="field-status">Join within</span>&nbsp;
								<span class="data-status" v-if="value.join_within">{{value.join_within}} days</span>
							</div>
							<!-- <div>
								<span class="field-status">Status</span>&nbsp;
								<span class="data-status" v-if="value.campaign_active">Active</span>
								<span class="data-status" v-else>InActive</span>
							</div> -->
						</p>
					</div>
				</div>
				<div v-else>
					<div class='step-content-line'>
						<p class='text active'>Select your promotion strategy and fill in basic information about this new promotion</p>
					</div>
				</div>
				<div class="header-step-stepper">
					<md-avatar class="md-avatar-icon stepper-content-num"  :class="{active:activeStep2}">
						<span v-if="stepNo==2">{{stepNo}}</span>
						<md-icon class='step-icon' v-if="stepNo!=2">mode_edit</md-icon>
					</md-avatar>
					<span class="card-title" :class="{active:activeStep2}">Select Products</span>
				</div>
				
				<div v-if="value.products.length > 0">
					<div class='step-content-line'>
						<p class='text active'>
							<div class="first-step2"> {{value.products.length}} Products Selected </div>
							<div class="second-title-step2"> Across 8 Product Groups </div>
						</p>
					</div>
				</div>
				<div v-else>
					<div class='step-content-line'>
						<p class='text'>Choose and set details for the products targeted in this campaign</p>
					</div>
				</div>
				<div class="header-step-stepper">
					<md-avatar class="md-avatar-icon stepper-content-num"  :class="{active:activeStep3}">
						<span v-if="stepNo==3">{{stepNo}}</span>
						<md-icon class='step-icon' v-if="stepNo!=3">mode_edit</md-icon>
					</md-avatar>
					<span class="card-title" :class="{active:activeStep3}">Condition Sets</span>
				</div>

				<div v-if="value.sets[0].name != ''">
					<div>
						<p class='text'>
							<md-card class="mkt-card" v-for="(item , index) in value.sets" v-bind:key="index">
								<div>
									<span class="name-set">{{value.sets[index].name== '' ? `SET ${(index+1)}` : value.sets[index].name}}</span>
								</div>
								<div>
									<span ><span class="title-condition" v-if="value.sets[index].point.start || value.sets[index].point.end">Point Require </span><span v-if="value.sets[index].point.start != null">{{value.sets[index].point.start.toLocaleString()}}</span> - <span v-if="value.sets[index].point.end != null">{{value.sets[index].point.end.toLocaleString()}}</span></span>
								</div>
								<div  v-for="(item,idx) in value.sets[index].rewards" :key="idx">
									<span class="title-reward">Reward </span><span>{{item.title}}</span>
								</div>
							</md-card>
						</p>
					</div>
				</div>
				<div v-else>
					<div class='step-content-line'>
						<p class='text'>Build you set of pricing and campaign conditions</p>
					</div>
				</div>

			</div>
			<md-dialog-confirm :md-active.sync="active" md-title="Confirm" :md-content="dialog_title" md-confirm-text="Sure" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="onConfirm" />
			<md-dialog-alert :md-active.sync="alert" md-title="Alert!" :md-content="dialog_title" />
		</div>
	</div>
</template>

<script>
import moment from "moment-timezone";
export default {
	name: "campaign-manage",
	props:['value','stepNo'],
	data(){
		return{
			dialog_title:"edit",
			active:false,
			alert:false,
			step: "step-1",
			activeStep1:true,
			activeStep2:false,
			activeStep3:false
		}
	},
	watch:{
		stepNo: function (val) {
			this.activeStep1 = false;
			this.activeStep2 = false;
			this.activeStep3 = false;
			if(val==1) this.activeStep1 = true;
			else if(val ==2) {this.activeStep1 = true; this.activeStep2 = true;}
			else if(val ==3) {this.activeStep1 = true; this.activeStep2 = true;this.activeStep3 = true;}
		}
	},
	methods:{
		onCancel(){

		},
		onConfirm(){

		},
		genDateView(startdate,enddate){
			//March 1, 2018 to April 31, 2018
			const date = moment(new Date(startdate));
			const date2 = moment(new Date(enddate));
			return `${date.format('MMMM D, YYYY')} to ${date2.format('MMMM D, YYYY')}`;
		}
	}
}
</script>

<style lang="scss" scoped>
.main-stepper{

	.step-content{

		font-size: 12px;

		.data-title{
			font-weight: bold;
			margin-right:5px;
		}
		.field-status{
			color:blue;
		}

		.mkt-card{
			width:220px;
			box-shadow: 0 0 1px #EFEFEF;
			border:#EFEFEF;
			padding-left: 20px;
			padding-top: 12px;
			padding-bottom: 12px;
			margin-bottom: 6px;
			height:88px;

			.name-set{
				font-weight: bold;
			}
			.title-condition{
				color:blue;
			}
			.title-reward{
				color:blue;
			}
		}

		.step-content-line{
			margin-left:10px;
			border-left:1px solid #EFEFEF;
			padding-left:10px;
			min-height: 70px;
			color:#414141;
		}

		.header-step-stepper {
				//min-width: 280px;
			padding-left: 0;
			padding-right: 0;
			font-weight: 500;

			.step-icon {
				font-size: 12px !important;
			}

			.md-avatar.md-avatar-icon.stepper-content-num {
				min-height: 24px;
				min-width: 24px;
				width: 24px;
				height: 24px;
				font-size: 12px;

				&.active {
					background-color: #3F51B5;
				}
			}

			.card-title {
				font-size: 14px;
				font-weight: 500;
				padding-left: 13px;
				color: #A8A8A8;

				&.active {
					color: #414141;
				}
			}
		}
	}



}
</style>